import React from 'react'

function NotFound() {
  return (
    <h1 className='noyFound'>Lo siento, te has perdido tienes que registrarte</h1>
  )
}

export default NotFound